import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: theme.spacing(1, 0, 4),
    padding: theme.spacing(2, 2, 1),
    borderWidth: 1,
    borderColor: theme.palette.divider,
    borderStyle: "solid",
  },
  rootHeader: { display: "flex", paddingBottom: theme.spacing(2) },
  headerSon: { display: "flex", justifyContent: "center", fontFamily: 'Montserrat', marginTop: theme.spacing(-2), },
  rootFooter: {
    paddingTop: theme.spacing(2),
    borderTopWidth: 1,
    borderTopColor: theme.palette.divider,
    borderTopStyle: "solid",
    display: "flex",
    justifyContent: "flex-end",
  },
  rootContent: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    borderTopWidth: 1,
    borderTopColor: theme.palette.divider,
    borderTopStyle: "solid",
  },

  contentBtnActionsFooter: {
    borderRightWidth: 1,
    borderRightColor: theme.palette.divider,
    borderRightStyle: "solid",
    paddingRight: theme.spacing(1),
    marginRight: theme.spacing(2),
  },
  inputQuestion: { marginRight: `${theme.spacing(2)} !important` },
  inputOptions: {
    display: "flex",
    marginBottom: theme.spacing(2),
    alignItems: "center",
  },
  btnAddOption: { marginBottom: theme.spacing(2) },
}));
